"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProviderLogo = require("./ProviderLogo");
Object.keys(_ProviderLogo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProviderLogo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProviderLogo[key];
    }
  });
});